/* eslint-disable camelcase */
import {PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS, ProductListController} from 'extensions/ui-controllers/product-list';

/**
 * @typedef {Object} RelatedListControllerResponse
 * @prop {number} total_count
 * @prop {number} start_offset
 * @prop {import('extensions/ui-controllers/product-list').MivaProduct[]} data
 */

export const RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS = {
	...PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS,
	functionName: 'Module',
	listCode: '',
	moduleCode: 'mvps-related-product-lists',
	moduleFunctionName: 'Runtime_ProductXRelatedProduct_List_Load_Query',
	productCode: ''
};

export class RelatedProductListController extends ProductListController {

	/**
	 * @type {RelatedListControllerResponse}
	 */
	response;

	constructor (host, options = RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS) {
		super(null, options);

		if (host) {
			// Add controller to host
			(this.host = host).addController(this);
		}

		// Set options
		this.functionName = options.functionName ?? RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS.functionName;
		this.moduleFunctionName = options.moduleFunctionName ?? RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS.moduleFunctionName;
		this.moduleCode = options.moduleCode ?? RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS.moduleCode;
		this.productCode = options.productCode ?? RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS.productCode;
		this.listCode = options.listCode ?? RELATED_PRODUCT_LIST_CONTROLLER_DEFAULT_OPTIONS.listCode;
	}

	get body () {
		const superBody = JSON.parse(super.body);

		const body = {
			...superBody,
			list_code: this.listCode,
			module_code: this.moduleCode,
			module_function: this.moduleFunctionName,
			product_code: this.productCode
		};

		return JSON.stringify(body);
	}
};
